import React from 'react'
import Accordion from './Accordion'

function FaqThree() {
    return (
        <>
            {/* Faq area Start */}
            <section id="faq" className="rts-faq-area rts-section-gap">
                <div className="container">
                    <div className="section-title-area2">
                        <p
                            className="sub-title cd wow fadeInUp"
                            data-wow-delay=".3s"
                            data-wow-duration="2s"
                        >
                            FAQs
                        </p>
                        <h2
                            className="section-title cd wow fadeInUp"
                            data-wow-delay=".5s"
                            data-wow-duration="2s"
                        >
                            Got Questions? We’ve <br /> Got Answers!"
                        </h2>
                    </div>
                    <div
                        className="faq-inner wow fadeInUp"
                        data-wow-delay=".8s"
                        data-wow-duration="2s"
                    >
                       <Accordion />
                    </div>
                    <div className="bottom-cta-area mt--100 rts-section-gap bg-two">
                        <div className="content">
                            <h2
                                className="title wow fadeInUp"
                                data-wow-delay=".2s"
                                data-wow-duration="2s"
                            >
                                Join the Revolution Today
                            </h2>
                            <p
                                className="desc wow fadeInUp"
                                data-wow-delay=".5s"
                                data-wow-duration="2s"
                            >
                                Don’t miss your chance to be part of the CoinCraze journey! Whether
                                you’re here to invest, explore, or simply enjoy the meme-powered
                                fun.
                            </p>
                            <div
                                className="button with-after wow fadeInUp"
                                data-wow-delay=".8s"
                                data-wow-duration="2s"
                            >
                                <a href="#" className="rts-btn btn-primary">
                                    Get Started Today
                                </a>
                            </div>
                        </div>
                        <div className="shape-area">
                            <img src="assets/images/cta/cta-bg-01.svg" alt="" />
                            <img src="assets/images/cta/cta-bg-02.svg" alt="" />
                            <img src="assets/images/cta/cta-bg-03.svg" alt="" />
                            <img
                                className="wow fadeInLeft"
                                data-wow-delay="1s"
                                data-wow-duration="2s"
                                src="assets/images/cta/cta-01.webp"
                                alt=""
                            />
                            <img
                                className="wow fadeInRight"
                                data-wow-delay="1s"
                                data-wow-duration="2s"
                                src="assets/images/cta/cta-02.webp"
                                alt=""
                            />
                        </div>
                    </div>
                </div>
            </section>
            {/* Faq area End */}
        </>

    )
}

export default FaqThree